import { IInformation } from '../../../interfaces/Information.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetInformationsParams {
  searchParam?: {
    category?: 'MAGAZINE' | 'NEWS';
    count?: number;
    page?: number;
  };
}

export const getInformations = ({ searchParam }: IGetInformationsParams): Promise<IInformation[]> => {
  if (searchParam?.category === null) {
    searchParam = { count: searchParam.count, page: searchParam.page };
  }

  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/informations?${URLSearchParams}`);
};
